// 쉼표를 찾는 정규식
export const commaRegex = /,/g;

// 숫자가 아닌 문자(Non-digit)를 찾는 정규식
export const nonDigitRegex = /[^0-9]/g;
